//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name:'MurrayLungInjuryScore',
  data() {
    return {
      defaultJson:{
        "PaO₂/FiO₂": "PaO₂/FiO₂比",
        "Hypoxemia score": "低氧血症评分",
        "compliance": "顺应性",
      },
      form:{
        method:-1,
        rate:'',
        peep:'',
        compliance:''
      },
      hasScore:false,
      disabled:false,
      dataList1:[
        {value:0,name:'0'},
        {value:1,name:'1'},
        {value:2,name:'2'},
        {value:3,name:'3'},
        {value:4,name:'4'},
      ],
      dataList2:[
        {value:"0",name:'>300mmHg',shortName:''},
        {value:"1",name:'225-299mmHg',shortName:''},
        {value:"2",name:'175-224mmHg',shortName:''},
        {value:"3",name:'100-174mmHg',shortName:''},
        {value:"4",name:'<100mmHg',shortName:''},
      ],
      dataList3:[
        {value:"0",name:'<5cmH₂O',shortName:''},
        {value:"1",name:'6-8cmH₂O',shortName:''},
        {value:"2",name:'9-11cmH₂O',shortName:''},
        {value:"3",name:'11-14cmH₂O',shortName:''},
        {value:"4",name:'>15cmH₂O',shortName:''},
      ],
      dataList4:[
        {value:"0",name:'>80mL/cmH₂O',shortName:''},
        {value:"1",name:'60-79mL/cmH₂O',shortName:''},
        {value:"2",name:'40-59mL/cmH₂O',shortName:''},
        {value:"3",name:'20-39mL/cmH₂O',shortName:''},
        {value:"4",name:'<19mL/cmH₂O',shortName:''},
      ],
      res:'...',

    }
  },
  rqed () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
    exclusiveChild(item, index) {
      this.form.method = item.value;
    }
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key]=='---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      console.log(form);
      if (!flag) {
        self.hasScore = false
        return '--'
      } else {
        let result = 0
        result = (form.method + form.rate + form.peep + form.compliance) / 4
        self.hasScore = true
        return String(result.toFixed(1))
      }
    }
  },
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Pulm/MurrayLungInjuryScore.vue